export default {
  namespace: "unitSetting",
  state: "1",
  reducers: {
    changeUnit(state, { payload }) {
        state = payload;
        return state;
      }
    },
  // 全局挂载函数，不能删！！！
  effects: {
    *updateUnit({ payload }, { call, put }) {
      try {
          yield put({
            type: "changeUnit",
            payload
          });
      } catch(err) {
        console.log("updateUnit error", err);
      }
    }
  }
}
